/**
 * Service de cotización (factoring).
 * Thin wrappers sobre API.factoring.*.
 */

import API from "@/api";

/**
 * Shape del endpoint consolidado GET /api/tenant/quote_settings.
 * Reemplaza la dupla legacy lista_parametros_cotizacion + onboarding params.
 * El backend resuelve el tenant por auth:api + Origin (identify_tenant_api),
 * por eso NO expone tenant_id en la respuesta.
 */
export interface TenantQuoteSettings {
	default_params: any;
	onboarding_params: {
		dias_diferencia: number;
		cond_min_fech_venc: number;
		max_min_fech_venc: number;
	} | null;
}

/**
 * Carga los parámetros de cotización del tenant (default + onboarding) en
 * una sola request. Retorna null en cualquier error para que el caller
 * decida el fallback (mantener defaults locales).
 */
export const tenantQuoteSettings = async (): Promise<TenantQuoteSettings | null> => {
	try {
		const body = await (API as any).factoring.tenant_quote_settings();
		if (body && body.error === false && body.data) {
			return body.data as TenantQuoteSettings;
		}
		return null;
	} catch (e) {
		return null;
	}
};

export const simularCotizacion = (payload: Record<string, unknown>) =>
	(API as any).factoring.simularCotizacion(payload);

export const crearCotizacion = (payload: Record<string, unknown>) =>
	(API as any).factoring.crear_cotizacion(payload);

export const verificarEmpresa = (payload: Record<string, unknown>) =>
	(API as any).factoring.verificar_empresa(payload);

export const subirRespaldoCotizacion = (formData: FormData) =>
	(API as any).factoring.subir_respaldo_cotizacion(formData);
